import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import MainLayout from "layouts/Main";
import { NORD_POOL_TABS } from "helpers/tabs";
import { grey } from "@mui/material/colors";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDropzone } from "react-dropzone";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { importClientTrades } from "api/resources/nordPool";

const NordPoolSupplyResults = () => {
  const [uploadedFile, setUploadedFile] = useState<File>(null);
  const [uploading, setUploading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);

  const onDrop = (acceptedFiles: any) => {
    setUploadedFile(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "text/csv": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    maxFiles: 1,
  });

  const handleSendFile = () => {
    if (uploadedFile) {
      setUploading(true);
      importClientTrades(uploadedFile)
        .then(() => {
          setUploading(false);
          setSnackbar({
            type: "success",
            message: "Nord Pool results uploaded successfully",
          });
        })
        .catch((error) => {
          console.error({ error });
          setUploading(false);
          setSnackbar({
            type: "error",
            message: "Error uploading results",
          });
        });
    }
  };

  const snackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar(null);
  };

  return (
    <MainLayout
      tabs={NORD_POOL_TABS}
      snackbar={{
        open: snackbar,
        handleClose: snackbarClose,
        type: snackbar?.type,
        message: snackbar?.message,
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h5">Results</Typography>
      </Box>
      <Box sx={{ mt: "2rem" }}>
        <Box
          {...getRootProps()}
          sx={{
            border: "2px dashed grey",
            padding: "20px",
            cursor: "pointer",
            backgroundColor: isDragActive ? grey[200] : grey[100],
            maxWidth: "700px",
          }}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <Typography>Drop the file here</Typography>
          ) : (
            <Typography component="p">
              Drag and drop the file here, or click to select from computer
            </Typography>
          )}
        </Box>

        {uploadedFile && (
          <Box mt={4}>
            <Typography component="p">Uploaded file:</Typography>
            <Typography
              component="p"
              style={{
                marginTop: "0.4rem",
                backgroundColor: grey[100],
                maxWidth: "max-content",
                padding: "6px 12px",
              }}
            >
              {uploadedFile.name}
            </Typography>
          </Box>
        )}

        {uploadedFile && (
          <Box sx={{ display: "flex", mt: 2 }}>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={handleSendFile}
              loading={uploading}
              loadingIndicator="Uploading..."
              startIcon={<FileUploadIcon />}
              sx={{ mr: 2 }}
              disabled={!uploadedFile || uploading}
            >
              Upload results
            </LoadingButton>
          </Box>
        )}
      </Box>
    </MainLayout>
  );
};

export default NordPoolSupplyResults;
